function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#38b1df;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Total Assets Icon");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("g", {
  id: "Group_562",
  "data-name": "Group 562"
}, React.createElement("g", {
  id: "Ellipse_55",
  "data-name": "Ellipse 55"
}, React.createElement("path", {
  className: "cls-1",
  d: "M11.5,23A11.5,11.5,0,1,1,23,11.5,11.51,11.51,0,0,1,11.5,23Zm0-20A8.5,8.5,0,1,0,20,11.5,8.51,8.51,0,0,0,11.5,3Z"
})), React.createElement("g", {
  id: "Path_114",
  "data-name": "Path 114"
}, React.createElement("path", {
  className: "cls-1",
  d: "M11.58,14l6.25,4.38L11.58,21,5.17,18.43Z"
})))));

var SvgTotalAssets = function SvgTotalAssets(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTotalAssets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/total-assets.bc75a20e.svg";
export { ForwardRef as ReactComponent };